import React, {useState} from "react";
import {Typography, Alert, IconButton} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

interface InfoMessageProps {
    message: string;
}

export const InfoMessage: React.FC<InfoMessageProps> = ({message}) => {
    const [isVisible, setIsVisible] = useState(true);

    if (!isVisible) return null;

    return (
        <Alert
            severity="info"
            icon={<InfoIcon />}
            action={
                <IconButton aria-label="close" color="inherit" size="small" onClick={() => setIsVisible(false)}>
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            }
            sx={{
                backgroundColor: "rgba(229, 246, 253, 1)",
                color: "#014361",
                "& .MuiAlert-icon": {
                    color: "#0288d1",
                },
            }}
        >
            <Typography fontSize="0.875rem">{message}</Typography>
        </Alert>
    );
};
